import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString } from '@/utils'

export default {
  fetch(params) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query { 
          chatTicketCosts ${parseObjectParamsToString(params)} {
            sum_costs_by_type {
              costs_by_business,
              costs_by_utility,
              costs_by_user
            },
            items {
              id,
              customer_id,
              instance_id
              chat_ticket_id,
              user_id,
              cost_user_brl,
              cost_utility_brl,
              cost_business_brl,
              business_initiated,
              created_at,
              ticket_is_open,
              user {
                id,
                name,
                image
              },
              instance {
                name
              }
            }
          }
        }
      `
    })
  }
}
